export const GLOBAL_FLAG_KEY = {
  RECRUITING_HR: 'admin.recruiting.enable-for-hr-admins',
}
